var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetainSnap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26736_3991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00006 3H3.50006C3.40505 3.00004 3.31202 3.02714 3.23186 3.07814C3.1517 3.12913 3.08773 3.20191 3.04744 3.28795C3.00714 3.37399 2.9922 3.46973 3.00435 3.56396C3.01651 3.65819 3.05525 3.747 3.11606 3.82L5.61606 6.82C5.70084 6.92063 5.82187 6.98379 5.95291 6.99577C6.08395 7.00775 6.21443 6.96759 6.31606 6.884C6.3391 6.86445 6.36051 6.84305 6.38006 6.82L8.88006 3.82C8.94065 3.74726 8.97935 3.65881 8.99165 3.56495C9.00395 3.47108 8.98934 3.37565 8.94954 3.28975C8.90973 3.20386 8.84636 3.13103 8.76679 3.07973C8.68722 3.02844 8.59472 3.00079 8.50006 3H7.00006V0.5C7.00006 0.367392 6.94738 0.240215 6.85361 0.146447C6.75984 0.0526784 6.63267 0 6.50006 0L5.50006 0C5.36745 0 5.24027 0.0526784 5.1465 0.146447C5.05274 0.240215 5.00006 0.367392 5.00006 0.5V3Z",
    fill: "#797B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0H9.5C9.36739 0 9.24021 0.0526784 9.14645 0.146447C9.05268 0.240215 9 0.367392 9 0.5C9 0.632608 9.05268 0.759785 9.14645 0.853553C9.24021 0.947322 9.36739 1 9.5 1H10C10.2652 1 10.5196 1.10536 10.7071 1.29289C10.8946 1.48043 11 1.73478 11 2V8H1V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H2.5C2.63261 1 2.75979 0.947322 2.85355 0.853553C2.94732 0.759785 3 0.632608 3 0.5C3 0.367392 2.94732 0.240215 2.85355 0.146447C2.75979 0.0526784 2.63261 0 2.5 0L2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V2C12 1.46957 11.7893 0.960859 11.4142 0.585786C11.0391 0.210714 10.5304 0 10 0Z",
    fill: "#797B80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26736_3991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetainSnap);
export default __webpack_public_path__ + "static/media/retainSnap.c3b21b90093d6a7f2f78699fc5832e41.svg";
export { ForwardRef as ReactComponent };